(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Transaction.Application.WorkflowChoice",
            {
                url: "/WorkflowChoice",
                component: "workflowChoice",
                resolve: {
                    prevStage: ["transaction", "_", function (transaction, _) {
                        if (transaction.DeterminePoints.includes("DetermineDocuments"))
                            return "Transaction.Determine.ProductSelected";
                        else
                            return "Transaction.Determine.ProductShelf";
                    }]
                },
                onEnter: ["transaction", "transactionApi", function(transaction, transactionApi) {
                    transaction.LastTransactionStage = "WorkflowChoice";
                    transactionApi.updateLastTransactionStage(transaction.Id, transaction);
                }]
            });
        }
    ]);
    app.component("workflowChoice",
    {
        templateUrl: "/App/Transaction/Application/WorkflowChoice/template.html",
        controller: workflowChoiceController,
        bindings: {
            transaction: "<",
            prevStage:"<"
        }
    });

    workflowChoiceController.$inject = ["$scope", "$state", "_"];
    function workflowChoiceController($scope, $state, _) {
        var $ctrl = this;
        $scope.$parent.$ctrl.getCurrentStage($state);
        $ctrl.ui = { Saving: [] };

        ng.extend($ctrl,
        {

        });


    }

})(window.app, window.angular); //jshint ignore:line